import { forwardRef, memo, useContext, useMemo } from 'react';
import size from 'lodash/size';
import { FormattedMessage } from 'react-intl';
// Skillmore UI Components
import CardSection from '@empathco/ui-components/src/elements/CardSection';
import CardsGrid from '@empathco/ui-components/src/components/CardsGrid';
// local imports
import { Employee } from '../models/employee';
import { GlobalContext } from '../context/global';
import EmployeeCard, { EmployeeCardItem, EmployeeCardProps } from '../v3/EmployeeCard';
// SCSS imports
import { footer } from './TbRosterList.module.scss';

type TbRosterListProps = {
  readonly roster?: Employee[];
}

const TbRosterList = forwardRef<HTMLDivElement, TbRosterListProps>(({
  roster
}, ref) => {
  const { paths: { supvEmplPath } } = useContext(GlobalContext);
  const all = size(roster);

  const componentProps: Partial<EmployeeCardProps> = useMemo(() => ({
    avatarVariant: 'grey',
    route: supvEmplPath,
    withZoomInSkills: true
  }), [supvEmplPath]);

  return (
    <>
      <CardsGrid
          ref={ref}
          items={roster as (EmployeeCardItem[] | null | undefined)}
          notFoundMessage="hr.teambuilder.no_roster"
          variant="dark"
          withoutTopPadding
          component={EmployeeCard}
          ComponentProps={componentProps}
      />
      {all > 0 && (
        <CardSection flex dark className={footer}>
          <FormattedMessage
              id="hr.teambuilder.review.allroster"
              values={{ all }}
          />
        </CardSection>)}
    </>
  );
});

TbRosterList.displayName = 'TbRosterList';

export default memo(TbRosterList);
